module.exports = __webpack_public_path__ + "e9c477e8/img/google.68f3823e.svg";